import React from "react";
import styled from "styled-components";

const StyledTabs = styled("div")`
  border: none;
  .nav-link {
    border: none;
    color: black;
    &.active {
      color: white;
      background: var(--brand-gradient-reverse);
      // background-attachment: fixed;
      svg {
        path {
          color: white !important;
          fill: currentColor !important;
        }
      }
    }
  }

  .nav-item button {
    // padding: 0 5px;
    font-weight: bold;
  }
`;

const StyledTabsFixedBackground = styled("div")`
  border: none;
  .nav-link {
    border: none;
    color: black;
    &.active {
      color: white;
      background: var(--brand-gradient-reverse);
      background-attachment: fixed;
      svg {
        path {
          color: white !important;
          fill: currentColor !important;
        }
      }
    }
    &:hover {
      color: white;
      background: var(--brand-gradient-reverse);
      background-attachment: fixed;
      opacity: 0.4;
      svg {
        path {
          color: white !important;
          fill: currentColor !important;
        }
      }
    }
  }
  .nav-item button {
    // padding: 0 5px;
  }
`;

export default function StyledTabContainer({
  id,
  children,
  isBackgroundFixed,
}: {
  id: string;
  children: React.ReactNode;
  isBackgroundFixed?: boolean;
}) {
  if (isBackgroundFixed) {
    return (
      <StyledTabsFixedBackground id={id}>{children}</StyledTabsFixedBackground>
    );
  }
  return <StyledTabs id={id}>{children}</StyledTabs>;
}
